import { Guid } from 'guid-typescript';
import { KeyValue } from '../models/common';
import { MenuItemResponse } from '../models/response';
import { getScreensWithoutModule } from './utils';

export function getGuidToString(guid?: string) {
  if (guid) {
    return Guid.parse(guid).toString();
  }
  return Guid.createEmpty().toString();
}

export function validateGuid(guid: any) {
  return Guid.isGuid(guid) && guid !== Guid.EMPTY;
}

export function getGuids(list: any) {
  const guids: string[] = [];
  if (list !== undefined && list.length > 0) {
    list.forEach((item: KeyValue) => {
      guids.push(item.key.toString());
    });
  }
  return guids;
}

export function getGuidScreenByRoute(pathName: string) {
  let guidScreen: string = '';
  const screens = getScreensWithoutModule();

  if (screens.length > 0) {
    const screen: MenuItemResponse | undefined = screens.find(
      (x: MenuItemResponse) => x.route === pathName
    );

    if (screen) {
      guidScreen = screen.guid;
    }
  }

  return guidScreen;
}

/**
 * Function to check if guid is valid
 *
 * @param {string} guid - Guid to check
 * @returns {boolean} Return true if guid is valid
 * @example
 * console.log(guidIsValid('00000000-0000-0000-0000-000000000000')); // false
 * console.log(guidIsValid('')); // false
 * console.log(guidIsValid(null)); // false
 * console.log(guidIsValid(undefined)); // false
 * console.log(guidIsValid('aaaa')); // false
 * console.log(guidIsValid('1234567-123')); // false
 *
 * console.log(guidIsValid('00000000-0000-0000-0000-000000000001')); // true
 */
export function guidIsValid(guid: string | null | undefined) {
  return !!guid && guid !== Guid.EMPTY && Guid.isGuid(guid);
}